import React from 'react';
import { PageHeaderPrimitives } from '@uhg-abyss/web/ui/PageHeader';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { IconMaterial } from '@uhg-abyss/web/ui/IconMaterial';
import PropTypes from 'prop-types';
import { useModal } from '@src/state/modal';
import { storage } from '@uhg-abyss/web/tools/storage';
import { AppSearch } from '../../../Header/LogoActionBar/AppSearch';
import { Trackit } from '../../TopNav';
import { useAppNav } from '../../useAppNav';

const StyledAppSearch = styled('div', {
  padding: '$md',
});

const StyledFlexDiv = styled('div', {
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
});

const MobileViewHorizontalRule = styled('div', {
  margin: '$sm 0',
  height: 0,
  width: '100%',
  borderTop: '1px solid $gray3',
});

const Wrapper = styled(PageHeaderPrimitives.DrawerLink, {
  '& span > span > svg': {
    display: 'none',
  },
  // eslint-disable-next-line consistent-return
  dynamic: ({ isInternalLink }) => {
    if (isInternalLink) {
      return {
        '& span > span > svg': {
          display: 'none',
        },
      };
    }
  },
});

export const HomeContent = ({ user, handleAppSearch, handleClick }) => {
  const { toggleModal } = useModal.actions();
  const appNavMenuItems = useAppNav();
  const openPermissionsModal = (name) => {
    toggleModal({ key: 'permissions', isOpen: true, toolName: name });
  };

  const openNavMenuExitLinkModal = (exitLink, name) => {
    const storageKey = `ExitLink-${exitLink.to}`;
    const allowModalOpen =
      exitLink.modalContent && !storage.local.get(storageKey);
    if (allowModalOpen) {
      toggleModal({
        key: 'NavMenuExitLink',
        isOpen: true,
        toolName: name,
        data: {
          ...exitLink,
          storageKey,
        },
      });
    } else {
      window.open(exitLink.to, '_blank');
    }
  };

  return (
    <React.Fragment>
      <StyledAppSearch>
        <AppSearch onSearch={() => handleAppSearch()} />
      </StyledAppSearch>
      <PageHeaderPrimitives.DrawerLink
        title='Training & Support'
        path='/home/trainingandsupport'
        data-testid='training-and-support-link'
      />
      <PageHeaderPrimitives.DrawerLink
        title='Practice Management'
        path='/home/practisemanagement'
        data-testid='practice-management-link'
      />
      <Wrapper
        title={
          <Layout.Group>
            <Trackit />
          </Layout.Group>
        }
        onClick={() => handleAppSearch()}
      />
      <PageHeaderPrimitives.DrawerLink
        title={
          <StyledFlexDiv
            data-testid='user-firstName-link'
            data-cy='profile-and-setting-dropdown-btn'
          >
            <IconMaterial icon='account_circle' />
            {user.firstName}
          </StyledFlexDiv>
        }
        path='/home/profile'
      />
      <MobileViewHorizontalRule />
      <For each='item' of={appNavMenuItems} index='index'>
        <Choose>
          <When condition={item.isBlocked}>
            <Wrapper
              title={item.name}
              data-testid={item.dataTestId}
              onClick={() => openPermissionsModal(item.name)}
            />
          </When>
          <When condition={item.exitLink}>
            <Wrapper
              title={item.name}
              data-testid={item.dataTestId}
              onClick={() => openNavMenuExitLinkModal(item.exitLink, item.name)}
            />
          </When>
          <Otherwise>
            <If condition={item.type === 'link'}>
              <Wrapper
                data-testId={item.dataTestId}
                title={item.name}
                onClick={() => handleClick(`${item.href}`)}
                isInternalLink
              />
            </If>
            <If condition={item.type === 'dropdown'}>
              <PageHeaderPrimitives.DrawerLink
                data-testId={item.dataTestId}
                title={item.name}
                path={`/home/${item.key}`}
              />
            </If>
          </Otherwise>
        </Choose>
      </For>
    </React.Fragment>
  );
};
HomeContent.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
  }).isRequired,
  handleAppSearch: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
};
